<script lang="ts">
    import { onMount } from 'svelte';
    import PageHeader from '../components/PageHeader.svelte';
    import { getEcosystemCategories } from '../scripts/apiEcosystems';
    import {
        storeEcosystemId, 
        storePartners, 
        EcosystemInterface, 
        storeEcosystemCategories,
        storeEcosystemCategoriesError,
        EcosystemCategory,
        emptyEcosystem,
    } from "../scripts/ecosystem";
    import { Enterprise, storeEnterprises, storeEnterprisesError } from '../scripts/enterprise';
    import {addNotificationError }  from "../scripts/toaster";
    import { storeLanguage, lang_fr, storeLoader } from "../scripts/store";
    import { launchLoader, stopLoader } from "../scripts/utils";
    import { getEnterprises } from '../scripts/apiEnterprises';
    import { redirectTo } from "../scripts/router1";
    import { getArticlesOfPartner, getArticles } from '../scripts/apiArticles';
    import { storePartnerArticles, storeArticle, storeArticles, storeArticlesError } from '../scripts/blog';
    import { idPageArticle } from "../scripts/router2";

    let partner: EcosystemInterface = emptyEcosystem;
    let labelDuration: string = "";
    let categories: EcosystemCategory[] = [];
    let clients: Enterprise[] = [];
    let articles;

    onMount(async () => {
        window.scrollTo(0,0);
        initData();
        getArticlesIfEmpty();
        
	});

    function initData() {
        getEnterprisesIfEmpty();
        storeEnterprises.subscribe(() => {
            initPartnerClients();
            partner = getPartnerInfos($storeEcosystemId);
            calculPartnerDuration(partner.date_partner);
            initPartnerCategories();
            getPartnerArticles($storeEcosystemId);
        })
        storePartnerArticles.subscribe((data) => {
            articles = data;
        })
    }

    /**
     * getPartnerInfos
     * 
     * @param id
     */
    function getPartnerInfos(id: number): EcosystemInterface {
        const partnerFiltered = $storePartners.filter(item => {
            return (item.id == id);
        })[0];
        return partnerFiltered;
    }

    /**
     * initPartnerCategories
     */
     function initPartnerCategories() {
        if ($storeEcosystemCategories.length <= 0) {
            getEcosystemCategories().then((data) => {
                if (!data) {
                    addNotificationError($storeEcosystemCategoriesError);
                }else {
                    categories = $storeEcosystemCategories.filter(item => {
                        return partner.categories.some(f => {
                            return f.id_ecosystem_category == item.id;
                        })
                    });
                }
            });
        } else {
            categories = $storeEcosystemCategories.filter(item => {
                return partner.categories.some(f => {
                    return f.id_ecosystem_category == item.id;
                })
            });
        }
    }

    /**
     * calculPartnerDuration
     * 
     * @param datePartner
     */
    function calculPartnerDuration(datePartner: string) {
        const toto = new Date();
        const yearNow = toto.getFullYear();
        const yearPartner = datePartner.substring(0,4);
        const diff = yearNow - parseInt(yearPartner);
        if (diff > 0) {
            labelDuration = diff.toString();
        } else {
            labelDuration = "";
        }
    }

    /**
     * initPartnerClients
     */
    function initPartnerClients() {
        clients = $storeEnterprises.filter(item => {
            let returnValue: boolean = false;
            partner.clients.forEach((client) => {
                if (client.id_enterprise == item.id) {
                    returnValue = true;
                }
            });
            return returnValue;
        });
    }

    /**
     * getEnterprisesIfEmpty
     */
     function getEnterprisesIfEmpty() {
        if ($storeEnterprises.length <= 0) {
            launchLoader();
            const returnValue = getEnterprises();
            returnValue.then((data) => {
                if (!data) {
                    addNotificationError("Erreur chargement entreprises");
                }
                stopLoader();
                if (!data) {
                    addNotificationError($storeEnterprisesError);
                };
            });
        }
    }

    
    /**
     * getPartnerArticles
     * 
     * @param id
     */
     function getPartnerArticles(id: number) {
        const returnValue = getArticlesOfPartner(id);
    }

    /**
     * selectArticle
     * @param articleId
     */
     function selectArticle(articleId: number) {
        filterArticle(articleId);
        redirectTo(idPageArticle, "?id="+articleId);        
    }

    /**
     * filterArticle
     * @param articleId
     */
     function filterArticle(articleId: number) {
        storeArticle.set($storeArticles.filter(item => {
            return (item.id == articleId);
        })[0]);
    }

    /**
     * getArticlesIfEmpty
     */
     function getArticlesIfEmpty() {
        if ($storeArticles.length <= 0) {
            const returnValue = getArticles();
            returnValue.then((data) => {
                if (!data) {
                    addNotificationError($storeArticlesError);
                };
            });
        }
    }

</script>
    
<style lang="scss">

    .partenaire {
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        align-items: center;
        width: 100%;
        &__bloc {
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            align-items: center;
        }
        &__name {
            padding: 60px 0 0 0;
            width: 100%;
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            align-items: center;
            text-align: center;
        }
        &__duration {
            padding: 60px 0 0 0;
            color: $color_orange;
            text-align: center; //*
        }
        &__presentation {
            padding: 60px 0 0 0;
            width: 100%;
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            align-items: stretch;
            &__description {
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                flex-wrap: wrap;
                padding: 15px 15px 15px 15px;
            }
            &__categories {
                margin: 60px 0 0 0;
                min-height: 100%;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                font-size: 25px;
                border: 1px solid $color-grey;
                border-radius: 10px;
                background-color: $color-light-grey;
                padding: 15px 15px 30px 15px;
                &__item {
                    margin: 30px 0 0 0;
                    width: 60%;
                    background-color: $color-primary;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    border-radius: 10px;
                    color: $color-white;
                    padding: 15px 15px 30px 15px;
                }
            }
        }
        &__clients {
            width: 100%;
            margin: 60px 0 0 0;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            border: 1px solid $color-orange;
            border-radius: 10px;
            color: $color_white;
            &__title {
                color: $color-orange;
                padding: 15px 0 0 0;
                font-size: 25px;
                text-align: center;
            }
            &__items {
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                padding: 30px 0 15px 0;
                &__img {
                    width: 150px;
                    margin: 15px;
                }
            }
        }

        &__why {
            margin: 60px 0 0 0;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            border: 1px solid $color-grey;
            border-radius: 10px;
            background-color: $color-light-grey;
            padding: 15px 15px 30px 15px;
            &__title {
                font-size: 25px;
            }
            &__text {
                margin: 25px 0 0 0;
            }
        }

        &__plus {
            margin: 60px 0 0 0;
            padding: 15px 15px 30px 15px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            background-color: $color-orange;
            border-radius: 10px;
            color: $color_white;
            &__text {
                width:100%;
            }
            &__img {
                width: 200px;
                height: 200px;
            }
        }

        &__keyandcontact {
            margin: 60px 0 60px 0;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            width: 100%;
            &__title {
                padding: 15px 15px 15px 15px;
                font-size: 25px;
            }
            &__key {
                width: 100%;
                grid-area: key;
                display: flex;
                flex-direction: column;
                justify-content: flex-start;
                align-items: center;
                background-color: $color-primary;
                border-radius: 10px;
                color: $color_white;
                margin: 0 0 60px 0;
                &__item {
                    width: 80%;
                    padding: 0px 15px 30px 15px;
                    display: flex;
                    flex-direction: row;
                    justify-content: flex-start;
                    align-items: center;
                }
                &__img {
                    width: 40px;
                    margin: 0 30px 0 0;
                }
                &__linkedin {
                    width: 40px;
                    height: 40px;
                    margin: 0 30px 0 0;
                    background-image: url("../assets/images/logo-linkedin-blanc.png");
                    background-size: cover;
	    		    background-repeat: no-repeat;
                    cursor: pointer;
                    transition: all;
                    transition-duration: 0.5s;
                    &:hover {
                        transform: scale(1.1);
                        background-image: url("../assets/images/logo-linkedin-orange.png");
                    }
                }
                &__website {
                    width: 40px;
                    height: 40px;
                    margin: 0 30px 0 0;
                    background-image: url("../assets/images/domaine.png");
                    background-size: cover;
	    		    background-repeat: no-repeat;
                    cursor: pointer;
                    transition: all;
                    transition-duration: 0.5s;
                    &:hover {
                        transform: scale(1.1);
                        background-image: url("../assets/images/domaine-hover.png");
                    }
                }
            }
            &__contact {
                width: 100%;
                grid-area: contact;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                background-color: $color-primary;
                border-radius: 10px;
                color: $color_white;
                &__photo {
                    align-self: flex-start;
                    width: 80px;
                    margin: 0 30px 0 0;
                    border-radius: 10px;
                }
            }
        }

        &__events {
            margin: 0 0 60px 0;
            padding: 15px 15px 30px 15px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            background-color: $color-orange;
            border-radius: 10px;
            color: $color_white;
            &__text {
                width:100%;
            }
        }

    }

    .blog {
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        align-items: center;
        width: 100%;
        &__bloc {
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            align-items: center;
        }
        &__title {
            margin: 50px 0 50px 0;
            align-self: flex-start;
        }
        &__articles {
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            flex-wrap: wrap;
            align-items: center;
            margin: 0 32px 0 32px;
            width: 100%;
        }
        &__article {
            margin: 0 0 50px 0;
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: center;
            background-color: $color-light-grey;
            box-shadow: 8px 8px 8px $color_text;
            border-radius: 20px 20px 20px 20px;
            min-height: 317px;
            width: 100%;
            &__photo {
                width: 100%;
                display: flex;
                flex-direction: column;;
                justify-content: center;
                align-items: center;
                &__img {
                    object-fit: cover;
                    object-position: 50% 0;
                    height: 167px;
                    width: 100%;
                    border-radius: 20px 20px 0 0;
                }
            }
            &__title {
                margin: 15px 0 0 0;
                max-width: 80%;
                overflow-y: hidden;
                display: -webkit-box;
                -webkit-line-clamp: 3;
                -webkit-box-orient: vertical;
            }
            &__subtitle {
                margin: 15px 0 30px 0;
                max-width: 80%;
                overflow-y: hidden;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
            }
            &__date {
                margin: 15px 0 0 0;
            }
            &__rate {
                display: flex;
                flex-direction: row;
                justify-content: flex-end;
                align-items: center;
                &__img {
                    width: 20px;
                    margin: 0 10px 0 0;
                }
            }
        }
    }

    @include large {
        .blog {
            &__articles {
                flex-direction: row;
                align-items: flex-start;
            }
            &__article {
                cursor: pointer;
                height: 400px;
                width: 30%;
                overflow-y: hidden;
                &__title {
                    grid-area: title;
                    cursor: pointer;
                    &__a {
                        text-decoration: none;
                    }
                }
                &__photo {
                    &__img {
                        height: 200px;
                        width: 100%;
                    }
                }
            }
        }
    }

    @include large {
        .partenaire {
            &__name {
                flex-direction: row;
            }
            &__presentation {
                width: 80%;
                flex-direction: row;
                &__description {
                    width: 100%;
                    min-height: 100%;
                    margin: 0 15px 0 0;
                    border: 1px solid $color-grey;
                    border-radius: 10px;
                    background-color: $color-light-grey;
                }
                &__categories {
                    margin: 0 0 0 15px;
                    width: 100%;
                }
            }
            &__clients {
                max-width: 80%;
                width: auto;
                &__title {
                    padding: 15px 15px 30px 15px;
                }
                &__items {
                    flex-direction: row;
                    flex-wrap: wrap;
                    &__img {
                        max-width: 250px;
                    }
                }
            }

            &__why {
                margin: 60px 0 0 0;
                min-width: 80%;
                max-width: 80%;
                padding: 0;
                &__title {
                    font-size: 25px;
                    padding: 15px 15px 15px 15px;
                }
                &__text {
                    padding: 15px 15px 30px 15px;
                }
            }

            &__plus {
                margin: 60px 0 0 0;
                min-width: 40%;
                max-width: 40%;
                padding: 0;
                &__text {
                    padding: 15px 30px 30px 30px;
                    text-align: center;
                    width: auto;
                }
                &__img {
                    width: 200px;
                    height: 200px;
                }
            }

            &__keyandcontact {
                display: grid;
                grid-template-areas: "key contact";
                grid-template-columns: 50% 50%;
                gap: 30px;
                justify-content: center;
                align-items: stretch;
                width: 80%;
                padding: 0;
                &__key {
                    grid-area: key;
                    margin: 0;
                }
                &__contact {
                    grid-area: contact;
                }
            }

            &__events {
                margin: 0 0 60px 0;
                min-width: 40%;
                max-width: 40%;
                padding: 0;
                &__text {
                    padding: 15px 30px 30px 30px;
                    text-align: center;
                    width: auto;
                }
            }

        }

    }

</style>

<div class="partenaire">
    {#if ($storeLanguage == $lang_fr)}
    <PageHeader props="Partenaire"/>
    {:else}
    <PageHeader props="Partner"/>
    {/if}
    <div class="bloc partenaire__bloc">
        <div class="partenaire__name font__h2">
            <div>{partner.name}</div>
        </div>
        <div class="partenaire__duration font__h3">
            {#if ($storeLanguage == $lang_fr)}
                {#if (labelDuration == "")}
                {partner.name} est fier d'être partenaire !
                {:else}
                {partner.name} est fier d'être partenaire depuis {labelDuration} ans !
                {/if}
            {:else}
                {#if (labelDuration == "")}
                {partner.name} is proud to be a partner!
                {:else}
                {partner.name} is proud to be a partner for {labelDuration} year!
                {/if}
            {/if}
        </div>
        <div class="partenaire__presentation">
            <div class="partenaire__presentation__description">
                {#if ($storeLanguage == $lang_fr)}
                {@html partner.description_fr}
                {:else}
                {@html partner.description_en}
                {/if}
            </div>
            <div class="partenaire__presentation__categories">
                <div class="font__h4">
                    {#if ($storeLanguage == $lang_fr)}
                    Typologies d’intervention
                    {:else}
                    Types of intervention
                    {/if}
                </div>
                {#each categories as category}
                <div class="font_h2 partenaire__presentation__categories__item" >
                    {#if ($storeLanguage == $lang_fr)}
                    {category.label_fr}
                    {:else}
                    {category.label_en}
                    {/if}
                </div>
                {/each}
            </div>
        </div>
        <div class="partenaire__clients">
            <div class="partenaire__clients__title font__h4">
                {#if ($storeLanguage == $lang_fr)}
                Nos principaux clients
                {:else}
                Our main customers
                {/if}
            </div>
            <div class="partenaire__clients__items">
                {#each clients as client}
                    <img class="partenaire__clients__items__img" title={client.name} alt={client.name} src="../assets/images/enterprises/{client.id}_{client.logo}">
                {/each}    
            </div>
        </div>
        {#if (partner.why_fr != undefined && partner.why_fr != null)}
        <div class="partenaire__why">
            {#if ($storeLanguage == $lang_fr)}
            <div class="partenaire__why__title font__h4">Pourquoi avons-nous rejoint l'aventure API Thinking ?</div>
            <div class="partenaire__why__text" >
                {@html partner.why_fr}
            </div>
            {:else}
            <div class="partenaire__why__title font__h4">Why did we join the API Thinking adventure?</div>
            <div class="partenaire__why__text" >
                {@html partner.why_en}
            </div>
            {/if}
        </div>
        {/if}
        {#if (partner.the_small_plus_fr != undefined && partner.the_small_plus_fr != null)}
        <div class="partenaire__plus">
            <img class="partenaire__plus__img" title="Le petit plus Collectif API Thinking" alt="Le petit plus Collectif API Thinking" src="../assets/images/le-petit-plus.png">
            <div class="partenaire__plus__text" >
                {#if ($storeLanguage == $lang_fr)}
                {@html partner.the_small_plus_fr}
                {:else}
                {@html partner.the_small_plus_en}
                {/if}
            </div>
        </div>
        {/if}
        <div class="partenaire__keyandcontact">
            <div class="partenaire__keyandcontact__key" >
                <div class="partenaire__keyandcontact__title font__h3">
                    {#if ($storeLanguage == $lang_fr)}
                    Chiffres Clé
                    {:else}
                    Key figures
                    {/if}
                </div>
                {#if (partner.date_creation != null)}
                <div class="partenaire__keyandcontact__key__item" >
                    <img class="partenaire__keyandcontact__key__img" title="Date création Collectif API Thinking" alt="Date création Collectif API Thinking" src="../assets/images/date-creation.png">
                    {#if ($storeLanguage == $lang_fr)}
                    Depuis&nbsp;{partner.date_creation.substring(0,4)}
                    {:else}
                    Since&nbsp;{partner.date_creation.substring(0,4)}
                    {/if}
                </div>
                {/if}
                {#if (partner.nb_collab != undefined && partner.nb_collab != null)}
                <div class="partenaire__keyandcontact__key__item" >
                    <img class="partenaire__keyandcontact__key__img" title="Collaborateurs Collectif API Thinking" alt="Collaborateurs Collectif API Thinking" src="../assets/images/nombre-collaborateurs.png">
                    {#if ($storeLanguage == $lang_fr)}
                    +&nbsp;{partner.nb_collab}&nbsp;collaborateurs
                    {:else}
                    +&nbsp;{partner.nb_collab}&nbsp;employees
                    {/if}
                </div>
                {/if}
                {#if (partner.nb_project != undefined && partner.nb_project != null)}
                <div class="partenaire__keyandcontact__key__item" >
                        <img class="partenaire__keyandcontact__key__img" title="Projets Collectif API Thinking" alt="Projets Collectif API Thinking" src="../assets/images/nombre-projets.png">
                        {#if ($storeLanguage == $lang_fr)}
                        +&nbsp;{partner.nb_project}&nbsp;projets
                        {:else}
                        +&nbsp;{partner.nb_project}&nbsp;projects
                        {/if}
                </div>
                {/if}
            </div>
            <div class="partenaire__keyandcontact__contact" >
                {#if (partner.contact == undefined || partner.contact.id == undefined)}
                <div class="partenaire__keyandcontact__title font__h3">
                    {#if ($storeLanguage == $lang_fr)}
                    Pas encore de contact : &#x28
                    {:else}
                    No contact yet: &#x28
                    {/if}
                </div>
                {:else}
                <div class="partenaire__keyandcontact__title font__h3">
                    {#if ($storeLanguage == $lang_fr)}
                    Contactez-nous !
                    {:else}
                    Contact us!
                    {/if}
                </div>
                <div class="partenaire__keyandcontact__key__item">
                    {#if (partner.contact.photo != undefined && partner.contact.photo != "")}
                    <img class="partenaire__keyandcontact__contact__photo" title="Contact" alt="Contact" src="../assets/images/partnercontacts/{partner.contact.id}_{partner.contact.photo}">
                    {:else}
                    <img class="partenaire__keyandcontact__contact__photo" title="Contact" alt="Contact" src="../assets/images/users/avatar.png">
                    {/if}
                    <div>
                        {partner.contact.first_name}&nbsp;{partner.contact.last_name}&nbsp;<br>
                        {#if ($storeLanguage == $lang_fr)}
                        {partner.contact.job_fr}<br>
                        {:else}
                        {partner.contact.job_en}<br>
                        {/if}
                        {#if (partner.contact.linkedin != undefined && partner.contact.linkedin != "")}
                        <a href="{partner.contact.linkedin}" target="_blank">
                            <div class="partenaire__keyandcontact__key__linkedin">&nbsp;</div>
                        </a>
                        {/if}
                    </div>
                </div>
                {#if (partner.contact.telephone != undefined && partner.contact.telephone != "")}
                <div class="partenaire__keyandcontact__key__item" >
                    <img class="partenaire__keyandcontact__key__img" title="Contact téléphone" alt="Contact téléphone" src="../assets/images/telephone.png">
                    {partner.contact.telephone}
                </div>
                {/if}
                {#if (partner.contact.email != undefined && partner.contact.email != "")}
                <div class="partenaire__keyandcontact__key__item" >
                    <img class="partenaire__keyandcontact__key__img" title="Contact mail" alt="Contact mail" src="../assets/images/enveloppe.png">
                    {partner.contact.email}
                </div>
                {/if}
                <div class="partenaire__keyandcontact__key__item" >
                    <a href="{partner.website}" target="_blank">
                        <div class="partenaire__keyandcontact__key__website">&nbsp;</div>
                    </a>
                    {#if ($storeLanguage == $lang_fr)}
                    Découvrez notre site internet !
                    {:else}
                    Visit our website!
                    {/if}
                </div>
                {/if}
            </div>
        </div>
        <div class="bloc blog__bloc">
            {#if ($storePartnerArticles.length != 0)}
            <div class="blog__title">
                {#if ($storeLanguage == $lang_fr && $storePartnerArticles.length != 0)}
                Vous retrouverez ici tous les articles de notre partenaire.
                {:else}
                Here you will find all the articles of our partner.
                {/if}
            </div>
            {/if}
            <div class="blog__articles">
                {#each $storePartnerArticles as itemArticle, i}
                <div class="blog__article" on:click={() => selectArticle(itemArticle.id)} on:keydown={() => selectArticle(itemArticle.id)}>
                    <div class="blog__article__photo">
                        <img class="blog__article__photo__img" src="../assets/images/articles/{itemArticle.id}_{itemArticle.photo}" alt="article">
                    </div>
                    <div class="blog__article__title">
                        <div class="font__h3">
                            {#if ($storeLanguage == $lang_fr)}
                            {itemArticle.title_fr}
                            {:else}
                            {itemArticle.title_fr}
                            {/if}
                        </div>
                    </div>
                    <div class="blog__article__subtitle font__h4">
                        {#if ($storeLanguage == $lang_fr)}
                        {itemArticle.subtitle_fr}
                        {:else}
                        {itemArticle.subtitle_fr}
                        {/if}
                    </div>
                </div>
                {/each}
            </div>
        </div>
        {#if (partner.events != undefined && partner.events != null && partner.events != "")}
        <div class="partenaire__events">
            <div class="partenaire__events__title font__h3">Les événements</div>
            <div class="partenaire__plus__text" >
                {@html partner.events}
            </div>
        </div>
        {/if}
 
    </div>
</div>
